import React, { useContext } from "react";
import { Context } from "../../context/Context";
export default function DropShadow() {
  const { state, setState ,handleUpdate} = useContext(Context);
  return (
    <div className="mt-5 w-full">
      <span className="text-sm text-gray-600 font-medium inline-block">
        BOX SHADOW
      </span>
      <br />
      <div className="grid grid-cols-4 gap-4 w-full mt-3">
        {state.window.shadow.map(({ value, selected, id }) => (
          <div className="w-14 h-14 relative mr-3 " key={value}>
            <input
              type="radio"
              id={value}
              name="background"
              className="appearance-none transform cursor-pointer outline-none -translate-y-1/2 -translate-x-1/2 absolute left-1/2 top-1/2 w-14 h-14 "
              checked={selected}
              value={value}
              onChange={(e) =>
                setState(
                  handleUpdate(e.target.value, state, ["window", "shadow"])
                )
              }
            />
            <label
              htmlFor={id}
              className="hover:shadow-lg w-14 h-14  rounded-md border  p-3 cursor-pointer focus:border-indigo-400 outline-none transition transition-duration-300 ease-out"
            >
              <div
                className={`w-full h-full bg-gray-100 shadow-${value} rounded-md`}
              ></div>
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}
